exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-ae6fd992]{padding:1rem;background-color:#e6f3fd5c;margin:0}", ""]);

// exports
